module.exports = __webpack_public_path__ + "static/chrisliebing_2-466306d8b90628ccc24dd15da85e8234.jpg";